'use client';

import { useFormStatus } from "react-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { signup } from '@/app/_lib/actions';
import { usePathname } from "next/navigation";

export default function SignupForm() {
    const pathname = usePathname();
  return (
        <form className="flex flex-col gap-4 mt-8 text-left text-foreground" action={signup} >
            <input type="hidden" name="pathname" value={pathname} />
            <div>
                <Input id="name" type="text" name="name" placeholder="Full Name"/>
            </div>
            <div>
                <Input id="email" type="text" name="email" placeholder="Email"/>
            </div>
            <div>
                <Input id="password" type="password" name="password" placeholder="Password" autoComplete="new-password"/>
            </div>
            <SignupButton/>            
            {/* <div
                className="flex h-8 items-end space-x-1"
                aria-live="polite"
                aria-atomic="true"
            >
                {errorMessage && (
                    <p className="text-sm text-destructive">{errorMessage}</p>
                )}
            </div> */}
        </form>
    );
}

function SignupButton()  {
    const { pending } = useFormStatus();

    return (
        <Button className="mt-3 cursor-pointer" aria-disabled={pending} >
            Sign Up
        </Button>
    );
}
